import {
    NySelectInput
} from 'nyse-web-tools-common/lib/react';
import type {NyFieldInput} from 'nyse-web-tools-common/lib/react/types';
import React from 'react';
import usePlatform from '../../hooks/usePlatform';
import useResource from '../../hooks/useResource.hook';

import {
    viewGBOBrokerCrdsResource
} from '../../resources/viewGBO.resource';

type FloorBrokerFirmSelectProps = {
    showInactive?: boolean;
} & Partial<NyFieldInput>;

export const FloorBrokerFirmSelect = React.memo<FloorBrokerFirmSelectProps>(
    (props) => {
        const { showInactive, ...fieldProps } = props;

        const gboResourceParams = {
            request: {
                mpidStatus: showInactive ? undefined : 'Active',
                mic: usePlatform()
            }
        };

        const brokerCrdsResource = useResource(
            viewGBOBrokerCrdsResource,
            gboResourceParams
        );

        return (
            <NySelectInput
                {...fieldProps}
                name={fieldProps.name}
                options={brokerCrdsResource.data}
                required={fieldProps.required}
                isLoading={brokerCrdsResource.pending}
                disabled={fieldProps.disabled ?? brokerCrdsResource.pending}
                showLabelAsValue
            />
        );
    }
);